<script>
    import { createEventDispatcher } from 'svelte'
    export let text
    export let id = ''
    export let removable = false
    
    const dispatch = createEventDispatcher ();
</script>

<style>
    .operator-item {
        display: inline-block;
        border-radius: 12px;
        padding: 1px 8px 1px;
        margin: 0 1px 2px 0;
        background-color: #6f899c;
        color: #fff;
        font-size: 12px;
        line-height: 14px;
    }
    .operator-item.removable:hover {
        background-color: #ff7675;
    }
</style>

{#if removable}
    <div class="operator-item avoid-selection" class:removable on:click={e => dispatch ('remove', { id })}>{text}</div>
{:else}
    <div class="operator-item avoid-selection">{text}</div> 
{/if}
